import {createMessageTemplateService, updateMessageTemplateService} from '@/services/messageTemplatesService'
import type {CreateMessageTemplateResponse, MessageTemplateChannel} from '@/types/MessageTemplate'

export type CreateMessageTemplateUseCaseParams = {
  templateID?: string
  name: string
  status: string
  scope: string
  active: boolean
  message: string
  channel: MessageTemplateChannel
}

export async function createMessageTemplateUseCase(
  params: CreateMessageTemplateUseCaseParams
): Promise<CreateMessageTemplateResponse> {
  const {templateID, ...request} = params
  return templateID ? updateMessageTemplateService(templateID, request) : createMessageTemplateService(request)
}
